import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { withLang } from "@/lib/lang";

/**
 * Drop-in replacement for react-router's <Link> that keeps internal navigation
 * inside the current language. Write `to="/products"` and it resolves to
 * `/ar/products` or `/en/products` automatically.
 *
 * External URLs, anchors and mailto/tel links pass through untouched.
 */
export const Link = forwardRef(({ to, ...rest }, ref) => {
  const { lang } = useLang();

  const isInternal =
    typeof to === "string" && to.startsWith("/") && !to.startsWith("//");

  return <RouterLink ref={ref} to={isInternal ? withLang(lang, to) : to} {...rest} />;
});

Link.displayName = "LocaleLink";
